import React, { useState } from 'react';
import './PropertyComp.scss';
import ProfileTitle from '../../admin_screens/customerDetail/CustomerProfile/ProfileTitle';
import ProfileLabelAndTitle from '../ProfileLabelAndTitle';

interface IPropertyDetailComp{
  payload: any;
  status?:string;
  width?: string;
  index:number;
}
const PropertyDetailComp: React.FC<IPropertyDetailComp> = ({ payload, index }) => {
  const [showTransactionDetail, setShowTransactionDetail] = useState(false);
  console.log(payload, 'property');

  return (
    <div>
      <ProfileTitle
        name="Property details"
        index={index}
        onClick={() => setShowTransactionDetail(!showTransactionDetail)}
        hasViewOnlyTab
      />
      {showTransactionDetail && (
        <>
          <ProfileLabelAndTitle
            content={payload}
            attribute={['propertyAddress', 'state', 'city', 'zipCode', 'campus', 'rentAmount', 'leaseFileDetails']}
            label={{
              propertyAddress: 'Address',
              state: 'State',
              city: 'City',
              zipCode: 'Zip Code',
              campus: 'Campus',
              rentAmount: 'Rent Amount',
              leaseFileDetails: 'Lease Agreement',
            }}
          />
        </>
      )}
    </div>
  );
};

export default PropertyDetailComp;
